(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-heading"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.collection-heading__description-wrapper').forEach(function(wrapper) {
      var btn = wrapper.querySelector('.collection-heading__read-more-btn');
      var btnText = btn ? btn.querySelector('.collection-heading__read-more-text') : null;

      if (!btn || !btnText) return;

      var readMoreText = btn.getAttribute('data-read-more') || 'Read more';
      var readLessText = btn.getAttribute('data-read-less') || 'Read less';

      function toggle() {
        var expanded = wrapper.getAttribute('data-expanded') === 'true';
        var next = !expanded;
        wrapper.setAttribute('data-expanded', next);
        btn.setAttribute('aria-expanded', next);
        btnText.textContent = next ? readLessText : readMoreText;
      }

      btn.addEventListener('click', function(e) {
        e.preventDefault();
        toggle();
      });

      btn.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          btn.click();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["four_hand-steps"] && !Shopify.designMode) return;
  try {
    

  window.addEventListener('load', function () {

    const slider = document.querySelector('.fhs-slider');
    const dotsWrap = document.querySelector('.fhs-slider-dots');

    if (!slider || !dotsWrap) return;

    const cards = slider.querySelectorAll('.fhs-card');

    if (!cards.length) return;

    dotsWrap.innerHTML = '';

    cards.forEach((card,index)=>{

      const dot = document.createElement('button');

      dot.className = 'fhs-dot';

      if(index === 0){
        dot.classList.add('active');
      }

      dot.addEventListener('click',()=>{

        card.scrollIntoView({
          behavior:'smooth',
          inline:'start'
        });

      });

      dotsWrap.appendChild(dot);

    });

    slider.addEventListener('scroll',()=>{

      const sliderCenter =
        slider.scrollLeft +
        slider.offsetWidth / 2;

      let activeIndex = 0;
      let closest = Infinity;

      cards.forEach((card,index)=>{

        const cardCenter =
          card.offsetLeft +
          card.offsetWidth / 2;

        const distance =
          Math.abs(sliderCenter - cardCenter);

        if(distance < closest){
          closest = distance;
          activeIndex = index;
        }

      });

      document
        .querySelectorAll('.fhs-dot')
        .forEach(dot=>dot.classList.remove('active'));

      document
        .querySelectorAll('.fhs-dot')
        [activeIndex]
        ?.classList.add('active');

    });

  });

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glp-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const heroButton = document.querySelector('.glphero-btn');

    if (!heroButton) return;

    heroButton.addEventListener('mouseenter', function () {
      heroButton.style.transform = 'translateY(-2px)';
    });

    heroButton.addEventListener('mouseleave', function () {
      heroButton.style.transform = 'translateY(0)';
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gruns_four_hands"] && !Shopify.designMode) return;
  try {
    

window.addEventListener('load', function () {

    const slider = document.querySelector('.fhsv2-slider');
    const dotsWrap = document.querySelector('.fhsv2-slider-dots');

    if (!slider || !dotsWrap) return;

    const cards = slider.querySelectorAll('.fhsv2-card');

    if (!cards.length) return;

    dotsWrap.innerHTML = '';

    cards.forEach((card, index) => {

        const dot = document.createElement('button');

        dot.className = 'fhsv2-dot';

        if (index === 0) {
            dot.classList.add('active');
        }

        dot.addEventListener('click', () => {

            card.scrollIntoView({
                behavior: 'smooth',
                inline: 'start',
                block: 'nearest'
            });

        });

        dotsWrap.appendChild(dot);

    });

    slider.addEventListener('scroll', () => {

        const sliderCenter =
            slider.scrollLeft + slider.offsetWidth / 2;

        let activeIndex = 0;
        let closest = Infinity;

        cards.forEach((card, index) => {

            const cardCenter =
                card.offsetLeft + card.offsetWidth / 2;

            const distance =
                Math.abs(sliderCenter - cardCenter);

            if (distance < closest) {
                closest = distance;
                activeIndex = index;
            }

        });

        document.querySelectorAll('.fhsv2-dot').forEach((dot) => {
            dot.classList.remove('active');
        });

        const activeDot =
            document.querySelectorAll('.fhsv2-dot')[activeIndex];

        if (activeDot) {
            activeDot.classList.add('active');
        }

    });

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lgd-hero-banner-2"] && !Shopify.designMode) return;
  try {
    
function initHeroBanners() {
    const heroes = document.querySelectorAll(".spy-plp-conatiner .hero");
    heroes.forEach(hero => {
        if (hero.dataset.sliderInit === "1") return;

        const cards = hero.closest('.spy-plp-conatiner').querySelectorAll(".product-card");
        if (!cards.length) return;

        hero.dataset.sliderInit = "1";
        const sectionId = hero.dataset.sectionId;

        const allDesktopBgs = [];
        const allMobileBgs = [];
        cards.forEach(card => {
            if (card.dataset.bgDesktop) allDesktopBgs.push(card.dataset.bgDesktop);
            if (card.dataset.bgMobile) allMobileBgs.push(card.dataset.bgMobile);
        });

        const SLIDE_COUNT = cards.length;
        const INTERVAL_MS = parseInt(hero.dataset.rotatorSpeed) || 3000;
        let index = 0;
        let timer = null;

        const getPreloadImages = (mainOnly) => {
            const isMobile = window.innerWidth <= 991;
            if (mainOnly) {
                return isMobile ? allMobileBgs : allDesktopBgs;
            }
            return isMobile ? allDesktopBgs : allMobileBgs;
        };

        function preload(urls) {
            return Promise.all(urls.map(src => {
                const img = new Image();
                img.src = src;
                return img.decode ? img.decode().catch(() => {})
                    : new Promise(res => { img.onload = img.onerror = res; });
            }));
        }

        function render() {
            const activeCard = cards[index % cards.length];
            const isMobile = window.innerWidth <= 991;
            const customBg = isMobile ? activeCard.dataset.bgMobile : activeCard.dataset.bgDesktop;

            hero.style.backgroundImage = customBg ? `url("${customBg}")` : '';
            cards.forEach((card, i) => card.classList.toggle("active", i === index));
        }

        function next() {
            index = (index + 1) % SLIDE_COUNT;
            render();
        }

        function start() {
            if (timer) return;
            render();
            timer = setInterval(next, INTERVAL_MS);
        }

        preload(getPreloadImages(true)).then(start);
        preload(getPreloadImages(false));

        const onResize = () => render();
        window.addEventListener("resize", onResize);

        cards.forEach(function(card) {
            card.addEventListener('click', function() {
                const scroll_to_bottom = card.dataset.scrollToBottom === "true";
                if (scroll_to_bottom) {
                    const target = document.getElementById('selected-filters-slider-container');
                    if (target) {
                        const offset = 80;
                        const top = target.getBoundingClientRect().top + window.scrollY - offset;
                        window.scrollTo({ top, behavior: 'smooth' });
                    } else {
                        window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
                    }
                    return;
                }
                const url = card.dataset.url;
                if (url && url !== '#') {
                    window.location.href = url;
                    return;
                }
                const target = document.getElementById('selected-filters-slider-container');
                if (target) {
                    const offset = 80;
                    const top = target.getBoundingClientRect().top + window.scrollY - offset;
                    window.scrollTo({ top, behavior: 'smooth' });
                }
            });
        });

        const onUnload = function(e) {
            if (e.detail.sectionId === sectionId) {
                clearInterval(timer);
                window.removeEventListener('resize', onResize);
                document.removeEventListener('shopify:section:unload', onUnload);
            }
        };
        document.addEventListener('shopify:section:unload', onUnload);
    });
}

if (document.readyState !== 'loading') {
    initHeroBanners();
} else {
    document.addEventListener("DOMContentLoaded", initHeroBanners);
}

document.addEventListener('shopify:section:load', function(e) {
    initHeroBanners();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lgd-hero-banner"] && !Shopify.designMode) return;
  try {
    
function initHeroBanners() {
    const heroes = document.querySelectorAll(".spy-plp-conatiner .hero");
    heroes.forEach(hero => {
        if (hero.dataset.sliderInit === "1") return;

        const cards = hero.closest('.spy-plp-conatiner').querySelectorAll(".product-card");
        if (!cards.length) return;

        hero.dataset.sliderInit = "1";
        const sectionId = hero.dataset.sectionId;

        const allDesktopBgs = [];
        const allMobileBgs = [];
        cards.forEach(card => {
            if (card.dataset.bgDesktop) allDesktopBgs.push(card.dataset.bgDesktop);
            if (card.dataset.bgMobile) allMobileBgs.push(card.dataset.bgMobile);
        });

        const SLIDE_COUNT = cards.length;
        const INTERVAL_MS = parseInt(hero.dataset.rotatorSpeed) || 3000;
        let index = 0;
        let timer = null;

        const getPreloadImages = (mainOnly) => {
            const isMobile = window.innerWidth <= 991;
            if (mainOnly) {
                return isMobile ? allMobileBgs : allDesktopBgs;
            }
            return isMobile ? allDesktopBgs : allMobileBgs;
        };

        function preload(urls) {
            return Promise.all(urls.map(src => {
                const img = new Image();
                img.src = src;
                return img.decode ? img.decode().catch(() => {})
                    : new Promise(res => { img.onload = img.onerror = res; });
            }));
        }

        function render() {
            const activeCard = cards[index % cards.length];
            const isMobile = window.innerWidth <= 991;
            if (window.innerWidth >= 768) {
              const customBg = isMobile ? activeCard.dataset.bgMobile : activeCard.dataset.bgDesktop;
              hero.style.backgroundImage = customBg ? `url("${customBg}")` : '';
            } else {
              hero.style.backgroundImage = '';
            }
            cards.forEach((card, i) => card.classList.toggle("active", i === index));
        }

        function next() {
            index = (index + 1) % SLIDE_COUNT;
            render();
        }

        function start() {
            if (timer) return;
            render();
            timer = setInterval(next, INTERVAL_MS);
        }

        preload(getPreloadImages(true)).then(start);
        preload(getPreloadImages(false));

        const onResize = () => render();
        window.addEventListener("resize", onResize);

        cards.forEach(function(card) {
            card.addEventListener('click', function() {
                const scroll_to_bottom = card.dataset.scrollToBottom === "true";
                if (scroll_to_bottom) {
 //               selected-filters-slider-container
                    const target = document.getElementById('shopify-section-template--27296164577593__main');
                    if (target) {
                        const offset = 80;
                        const top = target.getBoundingClientRect().top + window.scrollY - offset;
                        window.scrollTo({ top, behavior: 'smooth' });
                    } else {
                        window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
                    }
                    return;
                }
                const url = card.dataset.url;
                if (url && url !== '#') {
                    window.location.href = url;
                    return;
                }
                const target = document.getElementById('shopify-section-template--27296164577593__main');
                if (target) {
                    const offset = 80;
                    const top = target.getBoundingClientRect().top + window.scrollY - offset;
                    window.scrollTo({ top, behavior: 'smooth' });
                }
            });
        });

        const onUnload = function(e) {
            if (e.detail.sectionId === sectionId) {
                clearInterval(timer);
                window.removeEventListener('resize', onResize);
                document.removeEventListener('shopify:section:unload', onUnload);
            }
        };
        document.addEventListener('shopify:section:unload', onUnload);
    });
}

if (document.readyState !== 'loading') {
    initHeroBanners();
} else {
    document.addEventListener("DOMContentLoaded", initHeroBanners);
}

document.addEventListener('shopify:section:load', function(e) {
    initHeroBanners();
});

(function() {
    var VIDEO_SRC = 'https://image.shoplc.com/Web/Custom_PDP/shopify-lgd-2026/v/Luxuriant-Black-vs-White-1%20(1).mp4';
    var DELAY_MS = 5000;
    var FADE_MS = 850;

    function injectVideo() {
        if (window.innerWidth > 767) return;
        var img = document.querySelector('.dynamic-mobile-video');
        if (!img || img.dataset.videoInjected) return;
        img.dataset.videoInjected = '1';

        var container = img.parentNode;
        var video = document.createElement('video');
        video.className = 'hero-bg-video';
        // Set as HTML attributes — required for Safari to honour muted + autoplay
        video.setAttribute('autoplay', '');
        video.setAttribute('muted', '');
        video.setAttribute('loop', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', ''); // older iOS Safari
        // Mirror as JS properties for other browsers
        video.autoplay = true;
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        video.preload = 'auto';
        video.poster = img.currentSrc || img.src;
        video.src = VIDEO_SRC;

        // Insert invisible (opacity:0) so it can buffer under the poster
        container.appendChild(video);
        video.load();

        function reveal() {
            if (video.dataset.revealed) return;
            video.dataset.revealed = '1';

            video.play().catch(function() {});

            requestAnimationFrame(function() {
                video.classList.add('is-visible');
                img.classList.add('is-fading');
            });

            setTimeout(function() {
                if (img.parentNode) img.parentNode.removeChild(img);
                video.classList.add('is-settled');
            }, FADE_MS);
        }

        function revealWhenReady() {
            if (video.readyState >= 2) {
                reveal();
                return;
            }

            var done = false;
            function finish() {
                if (done) return;
                done = true;
                reveal();
            }

            video.addEventListener('loadeddata', finish, { once: true });
            video.addEventListener('canplay', finish, { once: true });
            // Don't leave the poster stuck if media events never fire
            setTimeout(finish, 2500);
        }

        setTimeout(revealWhenReady, DELAY_MS);
    }

    if (document.readyState !== 'loading') {
        injectVideo();
    } else {
        document.addEventListener('DOMContentLoaded', injectVideo);
    }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-phased"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quick-view-content"]) return;
  try {
    
  // Reset Quick Add drawer transform on mobile/tablet to prevent slide-in from right (up to 1199px)
  (function() {
    if (window.innerWidth > 1199) return; // Desktop only (1200px+) - skip

    function resetDrawerTransform(dialog) {
      if (!dialog) return;
      // Force reset transform to Y-axis only on mobile/tablet (up to 1199px)
      if (window.innerWidth <= 1199) {
        dialog.style.transform = 'translateY(100%) translateX(0)';
      }
    }

    // Listen for dialog close events
    document.addEventListener('dialog:close', function(event) {
      const dialog = event.target?.closest('dialog.drawer__dialog');
      if (dialog && dialog.closest('drawer-component[id^="drawer-quick-view"]')) {
        // Reset transform after close animation completes
        setTimeout(() => {
          resetDrawerTransform(dialog);
        }, 350); // Slightly longer than animation duration
      }
    });

    // Also reset when dialog-closing class is removed
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const dialog = mutation.target;
          if (dialog instanceof HTMLDialogElement && 
              dialog.closest('drawer-component[id^="drawer-quick-view"]') &&
              !dialog.classList.contains('dialog-closing') &&
              !dialog.hasAttribute('open') &&
              window.innerWidth <= 1199) {
            resetDrawerTransform(dialog);
          }
        }
      });
    });

    // Observe all quick-view drawer dialogs
    document.querySelectorAll('drawer-component[id^="drawer-quick-view"] dialog.drawer__dialog').forEach(function(dialog) {
      observer.observe(dialog, { attributes: true, attributeFilter: ['class', 'open'] });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc_video_section"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', () => {

    const slider = document.querySelector('.LP_ugc-video-slider');
    const cards = document.querySelectorAll('.ugc-video-card');
    const prev = document.querySelector('.ugc-prev');
    const next = document.querySelector('.ugc-next');
    const dotsWrap = document.querySelector('.ugc-dots');

    if (!slider || !cards.length) return;

    /* --------------------------
        CREATE DOTS
    ---------------------------*/

    dotsWrap.innerHTML = '';

    cards.forEach((card, index) => {

        const dot = document.createElement('button');

        dot.className = 'ugc-dot';

        if(index === 0){
            dot.classList.add('active');
        }

        dot.addEventListener('click',()=>{

            card.scrollIntoView({
                behavior:'smooth',
                inline:'center',
                block:'nearest'
            });

        });

        dotsWrap.appendChild(dot);

    });

    const dots = dotsWrap.querySelectorAll('.ugc-dot');

    /* --------------------------
        UPDATE ACTIVE DOT
    ---------------------------*/

    function updateDots(){

        let active = 0;

        let closest = Infinity;

        const center =
        slider.scrollLeft +
        slider.offsetWidth/2;

        cards.forEach((card,index)=>{

            const cardCenter =
            card.offsetLeft +
            card.offsetWidth/2;

            const distance =
            Math.abs(center-cardCenter);

            if(distance < closest){

                closest = distance;

                active = index;

            }

        });

        dots.forEach(dot=>dot.classList.remove('active'));

        dots[active]?.classList.add('active');

    }

    /* --------------------------
        PAUSE OTHER VIDEOS
    ---------------------------*/

    const videos =
    slider.querySelectorAll('video');

    videos.forEach(video=>{

        video.addEventListener('play',()=>{

            videos.forEach(v=>{

                if(v!==video){

                    v.pause();

                }

            });

        });

    });

    function pauseAll(){

        videos.forEach(video=>{

            video.pause();

        });

    }

    /* --------------------------
        ARROWS
    ---------------------------*/

    next?.addEventListener('click',()=>{

        slider.scrollBy({

            left:slider.clientWidth,

            behavior:'smooth'

        });

        pauseAll();

    });

    prev?.addEventListener('click',()=>{

        slider.scrollBy({

         left:-slider.clientWidth,

            behavior:'smooth'

        });

        pauseAll();

    });

    /* --------------------------
        SCROLL
    ---------------------------*/

    slider.addEventListener('scroll',()=>{

        updateDots();

    });

    /* --------------------------
        TOUCH
    ---------------------------*/

    let startX = 0;

    slider.addEventListener('touchstart',(e)=>{

        startX = e.touches[0].clientX;

    });

    slider.addEventListener('touchend',(e)=>{

        const endX = e.changedTouches[0].clientX;

        if(Math.abs(startX-endX)>60){

            updateDots();

        }

    });

    updateDots();

});


  } catch(e) { console.error(e); }
})();
})();
